import DateWidget from '../components/custom_widgets/DateWidget';
import InputWidget from '../components/custom_widgets/InputWidget';
import SelectWidget from '../components/custom_widgets/SelectWidget';
import CheckboxWidget from '../components/custom_widgets/CheckboxWidget';

/**
 * Override widgets for Katal customization.
 * https://katal.corp.amazon.com/
 */
export const CustomWidgets = {
    TextWidget: InputWidget,
    DateWidget: DateWidget,
    SelectWidget: SelectWidget,
    CheckboxWidget: CheckboxWidget,
    URLWidget: InputWidget
};
